import { combineReducers } from 'redux';
import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import Layout from './layout/reducers';
import Auth from './auth/reducers';
import User from './user/reducers';
import AppMenu from './appMenu/reducers';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['Auth']
};

const rootReducer = combineReducers({
    Auth,
    User,
    AppMenu,
    Layout,
});

export default persistReducer(persistConfig, rootReducer);
